import React from 'react';
import PropTypes from 'prop-types';

export class HelpIcon extends React.PureComponent {
  constructor(props) {
    super(props);
    this.element = React.createRef();
  }

  onClick = () => {
    // eslint-disable-next-line no-undef
    PopupController.PopupJsClick(this.element.current);
  };
  render() {
    const { topic, ariaLabel } = this.props;
    return (
      <button
        ref={this.element}
        className="helpbutton clickable"
        topic={topic.trim()}
        type="helppopup"
        onClick={this.onClick}
        aria-label={ariaLabel}
      />
    );
  }
}

HelpIcon.propTypes = {
  topic: PropTypes.string.isRequired,
  ariaLabel: PropTypes.string,
};
HelpIcon.defaultProps = {
  ariaLabel: '',
};
